const firstNameFromEmail = (email) => {
  const firstName = email.split("@")[0].split(".")[0];
  return firstName.charAt(0).toUpperCase() + firstName.slice(1);
};

export default firstNameFromEmail;
